<script>
export default {
  name: 'LanguageIconSVG',
  props: {
    color: {
      type: String,
      default: '#4D4D4D'
    }
  }
};
</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20.346" height="20.346" viewBox="0 0 20.346 20.346">
    <g id="Icon_-_biz_comm_-_language_black_24dp" data-name="Icon - biz comm - language_black_24dp" transform="matrix(-1, -0.017, 0.017, -1, 19.997, 20.346)">
      <g id="Boundary" fill="none" stroke="#707070" stroke-width="1" opacity="0">
        <rect width="20" height="20" stroke="none"/>
        <rect x="0.5" y="0.5" width="19" height="19" fill="none"/>
      </g>
      <path :fill="color" id="Path_3993" data-name="Path 3993" d="M9.992,2A8,8,0,1,0,18,10,8,8,0,0,0,9.992,2Zm5.544,4.8h-2.36a12.519,12.519,0,0,0-1.1-2.848A6.424,6.424,0,0,1,15.536,6.8ZM10,3.632A11.269,11.269,0,0,1,11.528,6.8H8.472A11.269,11.269,0,0,1,10,3.632ZM3.808,11.6a6.258,6.258,0,0,1,0-3.2h2.7A13.212,13.212,0,0,0,6.4,10a13.212,13.212,0,0,0,.112,1.6Zm.656,1.6h2.36a12.519,12.519,0,0,0,1.1,2.848A6.389,6.389,0,0,1,4.464,13.2Zm2.36-6.4H4.464A6.389,6.389,0,0,1,7.928,3.952,12.519,12.519,0,0,0,6.824,6.8ZM10,16.368A11.269,11.269,0,0,1,8.472,13.2h3.056A11.269,11.269,0,0,1,10,16.368ZM11.872,11.6H8.128A11.77,11.77,0,0,1,8,10a11.668,11.668,0,0,1,.128-1.6h3.744A11.668,11.668,0,0,1,12,10,11.77,11.77,0,0,1,11.872,11.6Zm.2,4.448a12.519,12.519,0,0,0,1.1-2.848h2.36A6.424,6.424,0,0,1,12.072,16.048ZM13.488,11.6A13.212,13.212,0,0,0,13.6,10a13.212,13.212,0,0,0-.112-1.6h2.7a6.258,6.258,0,0,1,0,3.2Z" />
    </g>
  </svg>
</template>
<style lang="scss">

</style>